import { RestSlice } from '../../../../../redux/rest.slice';
import { CccTestDto } from '@rcp/types';
import { localizationService } from 'src/services';

export const cccHazardTestsSlice = new RestSlice<CccTestDto>(
	localizationService.getLocalizedString('cccHazard.tests'),
	''
);
export default cccHazardTestsSlice.rests.reducer;
